export default {
    common: {
        close: "close",
        submit: "submit",
        answer: "answer",
        un_answer: "un answer",
        next: "next",
        see_all: 'see all',
        exam_result: 'tests have been scored',
        result: 'Result'
    },
    menu: {
        home: "home",
        my_test: "my test",
        exam_dashboard: 'Dashboard',
        catalog: "Test List",
        exam_recommendation: 'Recomdation Test',
        myprofile: "myprofile",
        information: "information",
        notification: "notification",
        notice: "notice",
        my_question: "my question",
        configuration: "configuration",
        account: "switch accounts",
        premium_service: "premium service",
        logout: "logout",
        dashboard: "dashboard"
    },
    exam_list: {
        start: "start exam",
        continue: "continue exam",
        time_over: "test time over",
        go_test_list: "Test List"
    },
    exam_show: {
        start: "start exam now",
        continue: "continue exam",
        time_over: "test time over",
        go_test_list: "Test List"
    },
    question: {
        warning_start_exam: "please start exam!",
        problem: "question",
        answer_number: "answer number",
        question: "question",
        description: "description",
        answer_rate: "your answer rate is",
        work_sheet: "work sheet",
        group: "Group",
        completion_status: 'Completion status',
        response: 'The current response rate is',
        done: 'If this is fine, click "Submit" on the left.',
        not_done: 'Click the unanswered question from the question menu on the left to answer.',
        progress: '%',
    },
    exam_result: {
        warning_finish_exam: "please finish exam!",
        failure: "failure",
        pass: "pass",
        place: "th place",
        people: "people",
        national_average: "national average",
        target_value: "target value",
        problem: "question",
        skill_items: "skill items",
        average_point: "average point",
        average: "average",
        description: "description",
        commentary: "解説",
        commentary_description: "情に棹させば流される。智に働けば角が立つ。どこへ越しても 住みにくいと悟った時、詩が生れて、画が出来る。とかくに人 の世は住みにくい。意地を通せば窮屈だ",
        check_score: "checking score.",
        show_detail: "show detail",
        stats: "stats"
    },
    user: {
        update_completed: "User Update Completed."
    }
}